import s from './home.module.css';

export default function PageHero(props: {
  eyebrow: string;
  title: React.ReactNode;
  sub: string;
}) {
  return (
    <section className={s.pageHero}>
      <div className="container">
        <span className={s.pageHeroEyebrow}>
          <span className={s.dot} />
          {props.eyebrow}
        </span>
        <h1 className={s.pageHeroTitle}>{props.title}</h1>
        <p className={s.pageHeroSub}>{props.sub}</p>
      </div>
    </section>
  );
}
